module.exports = __webpack_public_path__ + "static/preview-bslgov@2x-488947ba7b63679ec0ab97ecc080c352.png";